<app-spinner></app-spinner>
<div class="container-fluid">
    <h5 class="fw-bold mt-2">Admin Dashboard</h5>
    <!-- <div class="row g-3 my-3">
        <div class="col-md-3">
            <a [routerLink]="['/sdp/admin/user-management']" class="text-decoration-none text-dark">
                <div class="card h-100 text-center">
                    <div class="card-body p-6">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                            <g clip-path="url(#clip0_498_3302)">
                                <path
                                    d="M25.2917 30.625V27.7083C25.2917 26.1612 24.6771 24.6775 23.5831 23.5835C22.4892 22.4896 21.0054 21.875 19.4583 21.875H7.79167C6.24457 21.875 4.76084 22.4896 3.66688 23.5835C2.57292 24.6775 1.95834 26.1612 1.95834 27.7083V30.625M34.0417 30.625V27.7083C34.0407 26.4159 33.6105 25.1603 32.8187 24.1388C32.0268 23.1173 30.9181 22.3877 29.6667 22.0646M23.8333 4.56458C25.0881 4.88586 26.2003 5.61561 26.9945 6.63879C27.7887 7.66197 28.2198 8.92038 28.2198 10.2156C28.2198 11.5109 27.7887 12.7693 26.9945 13.7925C26.2003 14.8156 25.0881 15.5454 23.8333 15.8667M19.4583 10.2083C19.4583 13.43 16.8467 16.0417 13.625 16.0417C10.4033 16.0417 7.79167 13.43 7.79167 10.2083C7.79167 6.98667 10.4033 4.375 13.625 4.375C16.8467 4.375 19.4583 6.98667 19.4583 10.2083Z"
                                    stroke="#226CE0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_498_3302">
                                    <rect width="35" height="35" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                        <h6 class="card-title mt-3">User Management</h6>
                        <p class="card-text small text-muted">Manage system users and permissions</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-3">
            <a [routerLink]="['/sdp/admin/dep-management']" class="text-decoration-none text-dark">
                <div class="card h-100 text-center">
                    <div class="card-body">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                            <g clip-path="url(#clip0_498_3309)">
                                <path
                                    d="M18 21.875C20.4163 21.875 22.375 19.9163 22.375 17.5C22.375 15.0838 20.4163 13.125 18 13.125C15.5838 13.125 13.625 15.0838 13.625 17.5C13.625 19.9163 15.5838 21.875 18 21.875Z"
                                    stroke="#226CE0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M28.7917 21.875C28.5976 22.3149 28.5396 22.8028 28.6254 23.2759C28.7112 23.749 28.9367 24.1855 29.2729 24.5292L29.3604 24.6167C29.6316 24.8876 29.8467 25.2093 29.9935 25.5633C30.1403 25.9174 30.2158 26.297 30.2158 26.6803C30.2158 27.0635 30.1403 27.4431 29.9935 27.7972C29.8467 28.1512 29.6316 28.4729 29.3604 28.7438C29.0896 29.015 28.7679 29.2301 28.4138 29.3769C28.0597 29.5237 27.6802 29.5992 27.2969 29.5992C26.9136 29.5992 26.5341 29.5237 26.18 29.3769C25.8259 29.2301 25.5042 29.015 25.2333 28.7438L25.1458 28.6563C24.8021 28.3201 24.3656 28.0946 23.8925 28.0088C23.4195 27.923 22.9315 27.9809 22.4917 28.175C22.0603 28.3599 21.6925 28.6669 21.4334 29.0581C21.1743 29.4494 21.0352 29.9079 21.0333 30.3771V30.625C21.0333 31.3986 20.7261 32.1405 20.1791 32.6874C19.6321 33.2344 18.8902 33.5417 18.1167 33.5417C17.3431 33.5417 16.6013 33.2344 16.0543 32.6874C15.5073 32.1405 15.2 31.3986 15.2 30.625V30.4938C15.1887 30.0111 15.0325 29.543 14.7516 29.1502C14.4707 28.7575 14.0782 28.4584 13.625 28.2917C13.1852 28.0976 12.6972 28.0397 12.2242 28.1255C11.7511 28.2112 11.3145 28.4368 10.9708 28.773L10.8833 28.8605C10.6125 29.1316 10.2908 29.3468 9.93671 29.4936C9.58263 29.6403 9.2031 29.7159 8.8198 29.7159C8.43651 29.7159 8.05697 29.6403 7.70289 29.4936C7.34882 29.3468 7.02714 29.1316 6.75626 28.8605C6.48508 28.5896 6.26995 28.2679 6.12317 27.9138C5.97639 27.5597 5.90084 27.1802 5.90084 26.7969C5.90084 26.4136 5.97639 26.0341 6.12317 25.68C6.26995 25.3259 6.48508 25.0043 6.75626 24.7334L6.84376 24.6459C7.17996 24.3022 7.40549 23.8656 7.49127 23.3926C7.57704 22.9195 7.51914 22.4316 7.32501 21.9917C7.14015 21.5604 6.8332 21.1925 6.44194 20.9334C6.05068 20.6743 5.5922 20.5352 5.12293 20.5334H4.87501C4.10146 20.5334 3.3596 20.2261 2.81262 19.6791C2.26563 19.1321 1.95834 18.3903 1.95834 17.6167C1.95834 16.8432 2.26563 16.1013 2.81262 15.5543C3.3596 15.0073 4.10146 14.7 4.87501 14.7H5.00626C5.48896 14.6888 5.9571 14.5325 6.34982 14.2516C6.74254 13.9707 7.04168 13.5782 7.20834 13.125C7.40247 12.6852 7.46038 12.1973 7.3746 11.7242C7.28882 11.2511 7.06329 10.8146 6.72709 10.4709L6.63959 10.3834C6.36841 10.1125 6.15328 9.79082 6.0065 9.43674C5.85972 9.08266 5.78417 8.70313 5.78417 8.31983C5.78417 7.93654 5.85972 7.557 6.0065 7.20292C6.15328 6.84885 6.36841 6.52717 6.63959 6.25629C6.91047 5.98511 7.23215 5.76998 7.58623 5.6232C7.9403 5.47642 8.31984 5.40087 8.70314 5.40087C9.08643 5.40087 9.46597 5.47642 9.82005 5.6232C10.1741 5.76998 10.4958 5.98511 10.7667 6.25629L10.8542 6.34379C11.1979 6.67999 11.6344 6.90552 12.1075 6.9913C12.5806 7.07708 13.0685 7.01917 13.5083 6.82504H13.625C14.0563 6.64018 14.4242 6.33323 14.6833 5.94197C14.9424 5.55071 15.0815 5.09223 15.0833 4.62296V4.37504C15.0833 3.60149 15.3906 2.85963 15.9376 2.31265C16.4846 1.76566 17.2265 1.45837 18 1.45837C18.7736 1.45837 19.5154 1.76566 20.0624 2.31265C20.6094 2.85963 20.9167 3.60149 20.9167 4.37504V4.50629C20.9186 4.97556 21.0576 5.43405 21.3167 5.8253C21.5758 6.21656 21.9437 6.52351 22.375 6.70837C22.8149 6.9025 23.3028 6.96041 23.7759 6.87463C24.2489 6.78885 24.6855 6.56332 25.0292 6.22712L25.1167 6.13962C25.3876 5.86844 25.7092 5.65331 26.0633 5.50653C26.4174 5.35975 26.7969 5.28421 27.1802 5.28421C27.5635 5.28421 27.9431 5.35975 28.2971 5.50653C28.6512 5.65331 28.9729 5.86844 29.2438 6.13962C29.5149 6.4105 29.7301 6.73218 29.8769 7.08626C30.0236 7.44033 30.0992 7.81987 30.0992 8.20317C30.0992 8.58646 30.0236 8.966 29.8769 9.32008C29.7301 9.67415 29.5149 9.99583 29.2438 10.2667L29.1563 10.3542C28.8201 10.6979 28.5945 11.1344 28.5088 11.6075C28.423 12.0806 28.4809 12.5685 28.675 13.0084V13.125C28.8599 13.5564 29.1668 13.9242 29.5581 14.1833C29.9493 14.4425 30.4078 14.5815 30.8771 14.5834H31.125C31.8986 14.5834 32.6404 14.8907 33.1874 15.4376C33.7344 15.9846 34.0417 16.7265 34.0417 17.5C34.0417 18.2736 33.7344 19.0155 33.1874 19.5624C32.6404 20.1094 31.8986 20.4167 31.125 20.4167H30.9938C30.5245 20.4186 30.066 20.5576 29.6748 20.8167C29.2835 21.0759 28.9765 21.4437 28.7917 21.875Z"
                                    stroke="#226CE0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_498_3309">
                                    <rect width="35" height="35" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                        <h6 class="card-title mt-3">Department Config</h6>
                        <p class="card-text small text-muted">Manage departments and categories</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-3">
            <a [routerLink]="['/sdp/admin/escalation-matrix']" class="text-decoration-none text-dark">
                <div class="card h-100 text-center">
                    <div class="card-body">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                            <circle cx="18" cy="17.5" r="13.6667" stroke="#476CE0" stroke-width="4" />
                            <path d="M24.5625 17.5H18.25C18.1119 17.5 18 17.3881 18 17.25V12.3959" stroke="#476CE0"
                                stroke-width="4" stroke-linecap="round" />
                        </svg>
                        <h6 class="card-title mt-3">Escalation Matrix</h6>
                        <p class="card-text small text-muted">Configure complaint escalation rules</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-3">
            <a [routerLink]="['/sdp/admin/zone-word-mapping']" class="text-decoration-none text-dark">
                <div class="card h-100 text-center">
                    <div class="card-body">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                            <g clip-path="url(#clip0_498_3324)">
                                <path
                                    d="M12.1666 26.25L1.95831 32.0833V8.74996L12.1666 2.91663M12.1666 26.25L23.8333 32.0833M12.1666 26.25V2.91663M23.8333 32.0833L34.0416 26.25V2.91663L23.8333 8.74996M23.8333 32.0833V8.74996M23.8333 8.74996L12.1666 2.91663"
                                    stroke="#226CE0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_498_3324">
                                    <rect width="35" height="35" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                        <h6 class="card-title mt-3">Zone & Setup</h6>
                        <p class="card-text small text-muted">Manage geographical zones and wards</p>
                    </div>
                </div>
            </a>
        </div>
    </div> -->
    <div class="row g-3 mt-3 mb-3">
        <div class="col-md-3">
                        <a [routerLink]="['/sdp/mc/total-greviance']" class="text-decoration-none text-dark">

            <div class="card h-100 p-3">
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Total Complaints</h5>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <path
                            d="M3.75 12.5H7.75V21.5H3.75V12.5ZM17.75 8.5H21.75V21.5H17.75V8.5ZM10.75 2.5H14.75V21.5H10.75V2.5Z"
                            fill="#7A7FA1" />
                    </svg>
                </div>
                <h4 class="mt-3">{{totalComplaints}}</h4>
                <small class="text-muted">Across all department</small>
            </div>
                        </a>
        </div>
        <div class="col-md-3">
        <a [routerLink]="['/sdp/mc/pending-mc']" class="text-decoration-none text-dark">

            <div class="card h-100 p-3">
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Pending Complaints</h5>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                        <circle cx="8.75" cy="8.5" r="8.5" fill="#FFAE00" />
                    </svg>
                </div>
                <h4 class="mt-3">{{pendingCount}}</h4>
                <small class="text-warning">{{pendingPercentage}}% of total</small>
            </div>
        </a>
        </div>
        <div class="col-md-3">
                    <a [routerLink]="['/sdp/officer/resolved-complaints']" class="text-decoration-none text-dark">

            <div class="card h-100 p-3">
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Resolved Complaints</h5>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                        <circle cx="8.75" cy="8.5" r="8.5" fill="#00B74A" />
                    </svg>
                </div>
                <h4 class="mt-3">{{resolvedCount}}</h4>
                <small class="text-success">{{resolvedPercentage}}% of total</small>
            </div>
                    </a>
        </div>
        <div class="col-md-3">
                                <a [routerLink]="['/sdp/officer/closed-complaints']" class="text-decoration-none text-dark">

            <div class="card h-100 p-3">
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Closed Complaints</h5>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                        <circle cx="8.75" cy="8.5" r="8.5" fill="#FF3D00" />
                    </svg>
                </div>
                <h4 class="mt-3">{{closedCount}}</h4>
                <small class="text-danger">{{closedPercentage}}% of total</small>
            </div>
                                </a>
        </div>
            <div class="col-md-3">
                                <a [routerLink]="['/sdp/officer/escalated-complaints']" class="text-decoration-none text-dark">

            <div class="card h-100 p-3">
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Escalated Complaints</h5>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                        <circle cx="8.75" cy="8.5" r="8.5" fill="#FF3D00" />
                    </svg>
                </div>
                <h4 class="mt-3">{{escalatedCount}}</h4>
                <small class="text-danger">{{escalatedPercentage}}% of total</small>
            </div>
                                </a>
        </div>
    </div>
    <div class="card mb-3">
        <div class="card-body">
            <h5 class="card-title mb-3" style="font-size: 20px;">
                <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="24" height="24" viewBox="0 0 24 24"
                    fill="none">
                    <path
                        d="M15 17.6396L16 17.6397V17.6396H15ZM14.6582 18.1143L14.9743 19.063L14.9744 19.0629L14.6582 18.1143ZM9.6582 19.7803L9.34209 18.8316L9.34198 18.8316L9.6582 19.7803ZM9 19.3066H8L8 19.3073L9 19.3066ZM8.70711 11.7071L9.41421 11L8.70711 11.7071ZM15.2929 11.7071L14.5858 11L15.2929 11.7071ZM19.7071 7.29289L20.4142 8L19.7071 7.29289ZM19.7071 7.29289L19 6.58579L14.5858 11L15.2929 11.7071L16 12.4142L20.4142 8L19.7071 7.29289ZM15 12.4142H14V17.6396H15H16V12.4142H15ZM15 17.6396L14 17.6396C14 17.4254 14.1369 17.2339 14.342 17.1656L14.6582 18.1143L14.9744 19.0629C15.5878 18.8585 16 18.2843 16 17.6397L15 17.6396ZM14.6582 18.1143L14.3421 17.1655L9.34209 18.8316L9.6582 19.7803L9.97432 20.729L14.9743 19.063L14.6582 18.1143ZM9.6582 19.7803L9.34198 18.8316C9.66442 18.7241 9.99977 18.9636 10 19.306L9 19.3066L8 19.3073C8.00068 20.3319 9.00467 21.0522 9.97443 20.729L9.6582 19.7803ZM9 19.3066H10V12.4142H9H8V19.3066H9ZM8.70711 11.7071L9.41421 11L5 6.58579L4.29289 7.29289L3.58579 8L8 12.4142L8.70711 11.7071ZM4 6.58579H5V5H4H3V6.58579H4ZM5 4V5H19V4V3H5V4ZM20 5H19V6.58579H20H21V5H20ZM19 4V5H20H21C21 3.89543 20.1046 3 19 3V4ZM4 5H5V5V4V3C3.89543 3 3 3.89543 3 5H4ZM4.29289 7.29289L5 6.58579H5H4H3C3 7.11622 3.21071 7.62493 3.58579 8L4.29289 7.29289ZM9 12.4142H10C10 11.8838 9.78929 11.3751 9.41421 11L8.70711 11.7071L8 12.4142V12.4142H9ZM15.2929 11.7071L14.5858 11C14.2107 11.3751 14 11.8838 14 12.4142H15H16V12.4142L15.2929 11.7071ZM19.7071 7.29289L20.4142 8C20.7893 7.62493 21 7.11622 21 6.58579H20H19L19.7071 7.29289Z"
                        fill="#33363F" />
                </svg>Filter Complaints
            </h5>
            <div class="row g-3 mt-3">
                <div class="col-md-3">
                    <span>Department</span>
                    <ng-select [items]="allDepartment" bindLabel="department_name" bindValue="department_name"
                        [(ngModel)]="selectedDepartment" placeholder="Select Department " (change)="onFilterChange()"
                        [searchable]="true" [clearable]="true">
                    </ng-select>

                </div>
                <div class="col-md-3">
                    <span>Zone</span>
                    <ng-select [(ngModel)]="selectedZone" [items]="allZones" placeholder="All Zones"
                        (change)=" onFilterChange()" [clearable]="true" bindLabel="zone" [searchable]="true"
                        bindValue="zone">
                    </ng-select>
                </div>

                <div class="col-md-3">
                    <span>Status</span>
                    <ng-select [(ngModel)]="selectedStatus" [items]="statusArr" placeholder="All Statuses"
                        bindLabel="value" bindValue="code" (change)=" onFilterChange()" [clearable]="true">
                    </ng-select>
                </div>


                <!-- <div class="col-md-3">
                    <span>Created Date</span>
                    <ng-select [(ngModel)]="selectedcreate_date" [items]="complaints" placeholder="Dates" bindLabel="create_timestamp" bindValue="id"
                        (change)="onFilterChange()" [clearable]="true">
                    </ng-select>
                </div> -->
                <div class="col-md-3">
                    <label>Created Date</label>
                    <ng-select [items]="availableCreateDates" bindLabel="create_date" bindValue="create_date"
                        [(ngModel)]="selectedcreate_date" (change)="onFilterChange()" placeholder="All Dates"
                        [clearable]="true">
                    </ng-select>
                     <!-- <input type="date" class="form-control" [(ngModel)]="selectedcreate_date"
                    (change)="onFilterChange()" /> -->
                </div>



                <div class="col-12 mt-4 d-flex justify-content-end">
                    <button style="border-radius: 7px; background-color: white; border: 1px solid #ccc;"
                        (click)="clearFilter()">Clear Filter</button>
                </div>
            </div>
        </div>
    </div>
    <div class="card-overview mb-3">
        <div class="card-body">
            <h5 class="card-title mb-4" style="font-size: 20px;">Complaints Overview</h5>
            <div class="table-responsive">
                <table class="table table-bordered w-100">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Department</th>
                            <th>Zone</th>
                            <th>Status</th>
                            <th>Created</th>
                            <th style="text-align: center !important;">Days Open</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let comp of pagedComplaints; let i = index">
                            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
                            <td>{{comp.departments}}</td>
                            <td>{{ comp.zone }}</td>
                            <td>
                                <span class="ba" style="border-radius: 5px;" [ngStyle]="{
                  'background-color': 
                    comp.status === 'PENDING' ? '#FEF3C7' :
                    comp.status === 'GENERATED' ? '#FFD5CA' :
                    comp.status === 'RESOLVED' ? '#A2FFD0' :
                    comp.status === 'CLOSED' ? '#E2E2E2' : '',
                  'color':
                    comp.status === 'PENDING' ? '#601B02' :
                    comp.status === 'GENERATED' ? '#930404' :
                    comp.status === 'RESOLVED' ? '#05760C' :
                    comp.status === 'CLOSED' ? '#33363F' : ''
                }">
                                    {{ comp.status }}
                                </span>
                            </td>
                            <td>{{ comp.create_date }}</td>
                            <td class="text-danger" style="text-align: center !important;">{{ comp.number_of_open_days
                                }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
            <span style="color: #6D6D6D; font-size: 14px; font-weight: 300; line-height: 21px;">
                Showing {{ pagedComplaints.length }} of {{ filteredComplaints.length }} complaints
            </span>

            <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
                <label class="me-1">Per page:</label>
                <select [(ngModel)]="pageSize" (change)="changePageSize()" class="form-select form-select-sm w-auto">
                    <option *ngFor="let size of page_list" [value]="size">{{ size }}</option>
                </select>

                <button class="btn-sm fw-bold px-3 py-1 me-2" (click)="prevPage()" [disabled]="currentPage === 1"
                    title="Previous Page">
                    &lt;
                </button>

                <span style="font-weight: 600;">{{ currentPage }} / {{ totalPages }}</span>

                <button class="me-2 btn-sm fw-bold px-3 py-1" (click)="nextPage()"
                    [disabled]="currentPage === totalPages">
                    &gt;
                </button>
            </div>
        </div>

    </div>
</div>